import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";

import {PrimaryButton} from "../../../../components/Buttons";
import CompareIcon from "../../../../images/CompareIcon";

import styles from "./styles";


const PbButton = ({classes, text, onClick, icon}) => (
  <PrimaryButton
    text={text}
    icon={icon || <CompareIcon color={'currentColor'} />}
    onButtonClick={onClick}
    customClasses={{root: classes.pbButton}}
  />
);

export default withStyles(styles)(PbButton);